export default function HeroSection() {
  const scrollTo = (id: string) => {
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="hero" className="relative min-h-[600px] md:min-h-[680px] flex items-center bg-background-50 overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-primary-50/60 via-background-50 to-accent-50/40"></div>

      <div className="relative w-full max-w-[1280px] mx-auto px-4 md:px-6 py-20 md:py-24">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary-100/70 border border-primary-200/50 mb-5">
              <span className="w-2 h-2 rounded-full bg-primary-500 animate-pulse"></span>
              <span className="text-xs font-medium text-primary-700 whitespace-nowrap">每日更新 · 韩漫日漫国漫全覆盖</span>
            </div>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-950 leading-tight">
              星星动漫网<span className="text-primary-500">·</span>好看漫画的聚集地
            </h1>
            <p className="mt-3 text-base md:text-lg text-foreground-600 font-heading">
              韩漫日漫国漫漫画大全 —— 你想要的漫画，这里都有
            </p>

            <p className="mt-5 text-sm md:text-base text-foreground-600 leading-relaxed max-w-xl mx-auto lg:mx-0">
              星星动漫网是国内领先的免费漫画在线阅读平台，汇集韩漫、日漫、国漫三大品类热门好看漫画。
              编辑团队每日追踪各大漫画平台最新动态，确保热门连载第一时间同步上线。
              高清画质下拉式阅读，按地区与题材分类，轻松找到你喜欢的作品。
              无论你是热血战斗迷、甜宠恋爱控还是烧脑悬疑爱好者，这里都有属于你的漫画世界。
            </p>

            <div className="mt-6 flex flex-wrap items-center justify-center lg:justify-start gap-4 md:gap-6">
              <div className="flex items-center gap-1.5">
                <span className="text-xl md:text-2xl font-heading font-bold text-primary-600">17600+</span>
                <span className="text-xs text-foreground-500">部漫画资源</span>
              </div>
              <span className="w-px h-5 bg-background-300 hidden sm:block"></span>
              <div className="flex items-center gap-1.5">
                <span className="text-xl md:text-2xl font-heading font-bold text-accent-600">每日更新</span>
                <span className="text-xs text-foreground-500">热门连载</span>
              </div>
              <span className="w-px h-5 bg-background-300 hidden sm:block"></span>
              <div className="flex items-center gap-1.5">
                <span className="text-xl md:text-2xl font-heading font-bold text-primary-600">全免费</span>
                <span className="text-xs text-foreground-500">无需付费</span>
              </div>
            </div>

            <div className="mt-7 flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <button
                onClick={() => scrollTo('#ranking')}
                className="w-full sm:w-auto px-8 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold text-sm rounded-lg transition-all duration-200 whitespace-nowrap cursor-pointer active:scale-95"
              >
                <i className="ri-fire-line mr-2"></i>查看热门排行
              </button>
              <button
                onClick={() => scrollTo('#cards')}
                className="w-full sm:w-auto px-8 py-3 bg-background-50 hover:bg-background-100 text-foreground-800 font-medium text-sm rounded-lg border border-background-300 transition-all duration-200 whitespace-nowrap cursor-pointer active:scale-95"
              >
                <i className="ri-compass-3-line mr-2"></i>探索推荐漫画
              </button>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[480px] lg:max-w-none">
            <div className="relative rounded-2xl overflow-hidden bg-gradient-to-br from-primary-100/50 to-accent-100/40 border border-background-200/60">
              <img
                src="https://readdy.ai/api/search-image?query=Vibrant%20colorful%20anime%20manga%20style%20illustration%20collage%2C%20dynamic%20composition%20with%20multiple%20manga%20characters%20in%20action%20poses%2C%20warm%20orange%20and%20coral%20color%20palette%2C%20speed%20lines%20and%20motion%20effects%2C%20comic%20panel%20layout%20inspired%20design%2C%20energetic%20and%20eye-catching%2C%20clean%20white%20background%20with%20subtle%20gradient%2C%20modern%20flat%20illustration%20style%20with%20bold%20outlines&width=900&height=1100&seq=hero-comic-visual&orientation=portrait"
                alt="星星动漫网 - 韩漫日漫国漫漫画主角视觉合集"
                className="w-full h-auto object-contain"
                loading="eager"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}